<template>
  <div class="flex-col space-y-20 page">

    <div class="flex-col section_3">
      <div class="flex-col items-start group_3">
        <div class="flex-col items-start text-wrapper"><span class="text_2">培训记录</span></div>
      </div>
      <div class="flex-row group_4" style="flex-wrap: wrap; gap: 15px; align-items: flex-start; width: 100%;">
        <div class="flex-row items-center group_5" style="">
          <span class="text_5">证书名称：</span>
          <el-select 
              v-model="selectedCertId" 
              clearable 
              placeholder="请选择证书" 
              class=""
              @change="onCertificateChange" 
              :disabled="certLoading">
              <el-option 
                v-for="item in certificateList" 
                :key="item.id" 
                :label="item.certName || item.specialtyName"
                :value="item.id">
              </el-option>
            </el-select>
          
          <div class="select-container">
            
          </div>
        </div>

        <div class="flex-row items-center" style="margin-left: 100px; gap: 15px; margin-bottom: 10px; flex: 0 0 50% 0; justify-content: flex-end;">
          <div class="flex-col items-center text-wrapper_2" @click="getTrainingRecords"><span class="text_13">查询</span></div>
          <div class="flex-col items-center text-wrapper_3" @click="resetBtn"><span class="text_14">重置</span></div>
          <div class="flex-col items-center text-wrapper_2" style="min-width: 80px;" @click="openLearningCourse"><span class="text_13">学习课程</span></div>
        </div>


      </div>
      <div class="flex-col space-y-14 group_7" v-loading="loading" element-loading-text="数据正在加载中">
        <el-table :data="courseList" style="width: auto" :header-cell-style="{background:'#eef0f7bf'}" element-loading-text = "数据正在加载中" element-loading-spinner = "el-icon-loading">
          <el-table-column type="index" label="序号" width="auto" align="center"></el-table-column>
          <el-table-column prop="courseName" label="课程名称" width="460px" align="left"></el-table-column>
          <el-table-column prop="courseHours" label="学习时长(小时)" width="auto" align="center">
            <template slot-scope="scope">
              {{scope.row.courseHours || 0}}
            </template>
          </el-table-column>
          <el-table-column prop="startDate" label="学习开始日期" width="auto" align="center">
            <template slot-scope="scope">
              {{scope.row.startDate || '未知'}}
            </template>
          </el-table-column>
          <el-table-column prop="endDate" label="学习结束日期" width="auto" align="center">
            <template slot-scope="scope">
              {{scope.row.endDate || '未知'}}
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="姓名" width="auto" align="center">
            <template slot-scope="scope">
              {{trainingInfo.realName || '未知'}}
            </template>
          </el-table-column>
          <el-table-column prop="cardId" label="身份证号" width="auto" align="center">
            <template slot-scope="scope">
              {{trainingInfo.cardId || '未知'}}
            </template>
          </el-table-column>
          <el-table-column prop="certName" label="证书编号" width="auto" align="center">
            <template slot-scope="scope">
              {{trainingInfo.certName || '未知'}}
            </template>
          </el-table-column>
          <el-table-column prop="trainType" label="培训项目" width="auto" align="center">
            <template slot-scope="scope">
              {{trainingInfo.trainType || '未知'}}
            </template>
          </el-table-column>
          <el-table-column prop="zip" label="操作" width="auto" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="viewCourseDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 课程详情弹窗 -->
      <el-dialog
        title="课程详情"
        :visible.sync="detailDialogVisible"
        width="60%"
        :close-on-click-modal="false"
        custom-class="course-detail-dialog">
        <div class="course-detail-content">
          <p><strong>课程名称：</strong>{{ currentCourse.courseName }}</p>
          <p><strong>学习时长：</strong>{{ currentCourse.courseHours || 0 }}小时</p>
          <p><strong>学习开始日期：</strong>{{ currentCourse.startDate || '未知' }}</p>
          <p><strong>学习结束日期：</strong>{{ currentCourse.endDate || '未知' }}</p>
          <p v-if="currentCourse.userMonitorLog && currentCourse.userMonitorLog.length > 0"><strong>人脸监控记录：</strong></p>
          <table v-if="currentCourse.userMonitorLog && currentCourse.userMonitorLog.length > 0" style="width: 100%; border-collapse: collapse; margin-top: 10px;">
            <thead>
              <tr style="background-color: #f5f7fa;">
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 160px;">学习时间</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 90px;">学习终端</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 140px;">当前人脸</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 140px;">对比人脸</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 90px;">验证结果</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, index) in currentCourse.userMonitorLog" :key="index">
                <td style="border: 1px solid #ddd; padding: 8px; min-width: 160px;">{{ formatDateTime(log.startDate || log.gmtCreate) }}</td>
                <td style="border: 1px solid #ddd; padding: 8px; min-width: 90px;">{{ log.superviseType || '未知' }}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 140px;">
                  <img :src="log.currentImg" style="width: 80px; height: 80px; object-fit: cover; border: 1px solid #ddd;" />
                </td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center; min-width: 140px;">
                  <img :src="log.oldImg" style="width: 80px; height: 80px; object-fit: cover; border: 1px solid #ddd;" />
                </td>
                <td style="border: 1px solid #ddd; padding: 8px; min-width: 90px;">
                  <span :style="log.result === 1 ? 'color: #67C23A; font-weight: bold; border: 1px solid #67C23A; padding: 2px 6px; border-radius: 4px;' : 'color: #F56C6C;'">{{ log.result === 1 ? '通过' : '未通过' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        loading: false,
        certLoading: false,
        certificateList: [], // 证书列表
        selectedCertId: '', // 选中的证书ID
        courseList: [], // 课程列表
        userInfo: {}, // 用户信息
        trainingInfo: {}, // 培训信息
        detailDialogVisible: false, // 详情弹窗显示状态
        currentCourse: {}, // 当前查看的课程
      };
    },
    created() {
      let that = this;
      // 获取用户信息和培训记录
      that.getUserInfo();
      that.getTrainingRecords();
    },
    methods: {
      // 获取用户信息
      getUserInfo() {
        let that = this;
        that.$request.getUserInfo().then((res) => {
          if (res.code == 200) {
            that.userInfo = res.datas;
          }
        });
      },
      // 证书选择变化
      onCertificateChange() {
        let that = this;
        // 选择证书后立即获取课程详情
        that.getTrainingRecords();
      },
      // 获取培训记录
      getTrainingRecords() {
        let that = this;
        that.loading = true;
        let params = {};
        if (that.selectedCertId) {
          params.certId = that.selectedCertId;
        }
        
        that.$request.getTrainingRecords(params).then((res) => {
          that.loading = false;
          if (res.code === 200 && res.datas) {
            if (params.certId) {
              // 返回的是课程详情
              that.courseList = res.datas.list || [];
              that.count = res.datas.list ? res.datas.list.length : 0;
              // 保存培训信息
              that.trainingInfo = {
                realName: res.datas.realName,
                cardId: res.datas.cardId,
                certName: res.datas.certName,
                trainType: res.datas.trainType
              };
            } else {
              // 返回的是证书列表
              that.certificateList = res.datas.certificates || [];
              that.courseList = [];
              that.count = 0;
              
              // 如果有证书且未选择证书，默认选择第一个
              if (that.certificateList.length > 0 && !that.selectedCertId) {
                that.selectedCertId = that.certificateList[0].id;
                // 自动获取第一个证书的课程详情
                that.$nextTick(() => {
                  that.getTrainingRecords();
                });
              }
            }
          } else {
            that.certificateList = [];
            that.courseList = [];
            that.count = 0;
          }
        }).catch((err) => {
          that.loading = false;
          console.error('获取培训记录失败:', err);
          that.$myMessage.error('获取培训记录失败，请稍后重试');
        });
      },
      //重置搜索
      resetBtn() {
        let that = this;
        that.selectedCertId = '';
        that.courseList = [];
        // 重新获取证书列表
        that.getTrainingRecords();
      },
      // 打开学习课程
      openLearningCourse() {
        window.open('https://www.guobiaorc.com/', '_blank');
      },
      // 查看课程详情
      viewCourseDetail(item) {
        let that = this;
        that.currentCourse = item;
        that.detailDialogVisible = true;
      },
      // 格式化时间
      formatDateTime(dateTime) {
        if (!dateTime) return '未知';
        // 处理ISO格式的时间
        if (dateTime.includes('T')) {
          const date = new Date(dateTime);
          return date.toLocaleString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          });
        }
        return dateTime;
      }
    }
  };
</script>

<style scoped lang="css">
  .space-y-20>*:not(:first-child) {
    margin-top: 1.25rem;
  }

  .page {
    background-color: #f5f6fa;
    width: calc(100% - 220px) !important;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    padding: 1.25rem 1.25rem 1.88rem;
  }

  .page-box {
    margin: 1.65rem 0;
  }

  .section_1 {
    padding: 0.63rem 1.25rem 0.63rem 3.13rem;
    background-color: #ffffff;
  }

  .space-x-12>*:not(:first-child) {
    margin-left: 0.75rem;
  }

  .group {
    margin: 0.13rem 0;
    overflow: hidden;
    width: 15.56rem;
    height: 2.88rem;
  }

  .image {
    flex-shrink: 0;
    width: 2.88rem;
    height: 2.88rem;
  }

  .text {
    flex-shrink: 0;
    align-self: center;
    color: #3d3d3d;
    font-size: 1.5rem;
    font-family: Source Sans Pro;
    font-weight: 900;
    line-height: 1.41rem;
  }

  .space-x-15>*:not(:first-child) {
    margin-left: 0.94rem;
  }

  .group_1 {
    overflow: hidden;
    width: 12.88rem;
    height: 3.13rem;
  }

  .space-x-5>*:not(:first-child) {
    margin-left: 0.31rem;
  }

  .group_2 {
    overflow: hidden;
    width: 5.63rem;
    height: 3.13rem;
  }

  .image_1 {
    flex-shrink: 0;
    width: 2.5rem;
    height: 3.13rem;
  }

  .text_1 {
    align-self: center;
    color: #3d3d3d;
    font-size: 0.94rem;
    font-family: Source Sans Pro;
    font-weight: 700;
    line-height: 0.88rem;
  }

  .section_2 {
    align-self: center;
    background-color: #d8d8d8;
    width: 0.094rem;
    height: 0.81rem;
  }

  .image_2 {
    align-self: center;
    width: 1.13rem;
    height: 1.13rem;
  }

  .section_3 {
    /* margin-right: 1.25rem; */
    padding: 0.94rem 0.94rem;
    align-self: auto;
    background-color: #ffffff;
    border-radius: 0.63rem;
    /* width: 71.56rem; */
  }

  .group_3 {
    margin-right: 0.31rem;
    overflow: hidden;
    border-bottom: solid 0.016rem #c0c4cc;
  }

  .text-wrapper {
    padding: 0.22rem 0 1.28rem;
    width: 6.75rem;
    border-bottom: solid 0.16rem #0074ff;
  }

  .text_2 {
    color: #0074ff;
    font-size: 1.13rem;
    font-family: Source Sans Pro;
    font-weight: 900;
    line-height: 1.06rem;
  }

  .group_4 {
    margin-top: 1.69rem;
    align-self: flex-start;
    overflow: hidden;
    /* width: 59.69rem; */
  }

  .space-x-8>*:not(:first-child) {
    margin-left: 0.5rem;
  }

  .group_5 {
    width: 12.63rem;
    /* height: 2.19rem; */
  }

  .text_3 {
    flex-shrink: 0;
    align-self: center;
    color: #3d3d3d;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .space-x-45>*:not(:first-child) {
    margin-left: 2.81rem;
  }

  .section_4 {
    flex-shrink: 0;
    padding: 0.59rem 0.5rem 0.66rem;
    border-radius: 0.31rem;
    height: 2.19rem;
    border: solid 0.031rem #dcdfe6;
  }

  .text_4 {
    color: #c0c4cc;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .image_6 {
    margin-right: 0.16rem;
    flex-shrink: 0;
    width: 0.88rem;
    height: 0.88rem;
  }

  .group_6 {
    margin-left: 0.94rem;
    overflow: hidden;
    width: 10.69rem;
    height: 2.19rem;
  }

  .text_5 {
    flex-shrink: 0;
    align-self: center;
    color: #3d3d3d;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .space-x-14>*:not(:first-child) {
    margin-left: 0.88rem;
  }

  .text_7 {
    color: #c0c4cc;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text_11 {
    margin-left: 1rem;
    align-self: center;
    color: #3d3d3d;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text-wrapper_1 {
    margin-left: 0.53rem;
    padding: 0.59rem 0 0.72rem;
    border-radius: 0.31rem;
    height: 2.19rem;
    border: solid 0.031rem #dcdfe6;
  }

  .text_12 {
    margin-left: 0.5rem;
    margin-right: 0.56rem;
    color: #c0c4cc;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text-wrapper_2 {
    margin-left: 0.94rem;
    padding: 0.69rem 0;
    background-color: #0074ff;
    border-radius: 0.31rem;
    width: 3rem;
    height: 2.19rem;
    cursor: pointer;
  }

  .text_13 {
    color: #ffffff;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
    cursor: pointer;
  }

  .text-wrapper_3 {
    margin-left: 0.91rem;
    padding: 0.63rem 0 0.72rem;
    border-radius: 0.31rem;
    width: 3rem;
    height: 2.19rem;
    border: solid 0.031rem #dcdfe6;
    cursor: pointer;
  }

  .text_14 {
    color: #3d3d3d;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .space-y-14>*:not(:first-child) {
    margin-top: 0.88rem;
  }

  .group_7 {
    padding: 1.25rem 0.44rem 0;
  }

  .section_5 {
    margin-bottom: 1rem;
    background-color: #ffffff;
    border: solid 0.063rem #dcdfe6;
  }

  .section_6 {
    padding: 0.53rem 1.13rem 0.59rem;
    background-color: #fbfcff;
    border: solid 0.063rem #dcdfe6;
  }

  .text_15 {
    align-self: center;
    color: #9a9da7;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text-wrapper_4 {
    margin-right: 0.41rem;
    padding: 0.47rem 0 0.66rem;
    background-color: #fef0f0;
    border-radius: 0.31rem;
    width: 3.75rem;
    height: 1.88rem;
    border: solid 0.031rem #fde2e2;
  }

  .text_17 {
    color: #f56c6c;
    font-size: 0.75rem;
    font-family: Source Sans Pro;
    line-height: 0.69rem;
  }

  .space-y-10>*:not(:first-child) {
    margin-top: 0.63rem;
  }

  .group_8 {
    margin: 0.94rem 1.53rem 0 1.16rem;
    overflow: hidden;
  }

  .text_19 {
    margin-bottom: 0.13rem;
    color: #3d3d3d;
    font-size: 1.13rem;
    font-family: Source Sans Pro;
    font-weight: 900;
    line-height: 1.06rem;
  }

  .space-x-6>*:not(:first-child) {
    margin-left: 0.38rem;
  }

  .group_10 {
    padding: 0.16rem 0 0.16rem 0.094rem;
    overflow: hidden;
    /* width: 8rem; */
    height: 1.25rem;
  }

  .text_21 {
    flex-shrink: 0;
    color: #3d3d3d;
    font-size: 1rem;
    font-family: Source Sans Pro;
    line-height: 0.94rem;
  }

  .text_23 {
    margin-top: 0.19rem;
    flex-shrink: 0;
    color: #ff5f5a;
    font-size: 1rem;
    font-family: Source Sans Pro;
    font-weight: 900;
    line-height: 0.66rem;
  }

  .space-x-10>*:not(:first-child) {
    margin-left: 0.63rem;
  }

  .group_11 {
    align-self: flex-start;
  }

  .text-wrapper_5 {
    flex: 1 1 auto;
    padding: 0.47rem 0 0.66rem;
    background-color: #ffffff;
    border-radius: 0.31rem;
    width: 4.25rem;
    height: 1.88rem;
    border: solid 0.031rem #b3d8ff;
  }

  .text_25 {
    color: #0074ff;
    font-size: 0.75rem;
    font-family: Source Sans Pro;
    line-height: 0.69rem;
  }

  .text-wrapper_6 {
    flex-shrink: 0;
    padding: 0.47rem 0 0.66rem;
    background-color: #ffffff;
    border-radius: 0.31rem;
    width: 2.75rem;
    height: 1.88rem;
    border: solid 0.031rem #b3d8ff;
  }

  .text_27 {
    color: #0074ff;
    font-size: 0.75rem;
    font-family: Source Sans Pro;
    line-height: 0.69rem;
  }

  .section_7 {
    margin-top: 0.88rem;
    padding: 0.41rem 1.13rem;
    background-color: #ffffff;
    border: solid 0.063rem #dcdfe6;
  }

  .text_29 {
    color: #7d7d8c;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text_30 {
    align-self: center;
  }

  .group_12 {
    margin-right: 0.47rem;
  }

  .text-wrapper_7 {
    padding: 0.69rem 0;
    background-color: #0074ff;
    color: #fff;
    border-radius: 0.31rem;
    width: 5.63rem;
    height: 2.19rem;
    cursor: pointer;
  }

  .text-wrapper_71 {
    padding: 0.69rem 0;
    background-color: #0074ff;
    border-radius: 0.31rem;
    width: 5.63rem;
    height: 2.19rem;
    cursor: pointer;
  }

  .text_31 {
    color: #0074ff;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text_311 {
    color: #fff;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text-wrapper_8 {
    padding: 0.69rem 0;
    background-color: #0074ff;
    border-radius: 0.31rem;
    width: 5.63rem;
    height: 2.19rem;
    cursor: pointer;
  }

  .text_33 {
    color: #ffffff;
    font-size: 0.88rem;
    font-family: Source Sans Pro;
    line-height: 0.81rem;
  }

  .text-wrapper_9 {
    margin-right: 0.41rem;
    padding: 0.47rem 0 0.66rem;
    background-color: #f4f4f5;
    border-radius: 0.31rem;
    width: 3.75rem;
    height: 1.88rem;
    border: solid 0.031rem #e9e9eb;
  }

  .text_36 {
    color: #909399;
    font-size: 0.75rem;
    font-family: Source Sans Pro;
    line-height: 0.69rem;
  }

  .group_14 {
    align-self: flex-start;
  }

  .text-wrapper_10 {
    margin-top: 0.88rem;
    padding: 1.03rem 0 1.16rem;
    background-color: #ffffff;
    /* width: 68.75rem; */
    border: solid 0.063rem #dcdfe6;
  }

  .text_43 {
    margin-left: 1.13rem;
  }

  .group_16 {
    align-self: flex-start;
  }

  .group_18 {
    padding: 0.16rem 0;
    overflow: hidden;
    width: 8rem;
    height: 1.25rem;
  }

  .group_19 {
    align-self: flex-start;
  }

  .section_8 {
    margin-top: 0.88rem;
    padding: 0.41rem 1.13rem 0.41rem 1.13rem;
    background-color: #ffffff;
    border: solid 0.063rem #dcdfe6;
  }

  .text_60 {
    align-self: center;
  }

  .text-wrapper_11 {
    padding: 0.69rem 0 0.47rem;
    background-color: #f5f8ff;
    border-radius: 0.31rem 0.31rem 0 0;
    width: 5.63rem;
    height: 1.97rem;
  }

  .text-wrapper_12 {
    padding: 0.69rem 0 0.47rem;
    background-color: #0074ff;
    border-radius: 0.31rem 0.31rem 0 0;
    width: 5.63rem;
    height: 1.97rem;
  }
</style>

<style>
  /* 课程详情弹窗样式 */
  .course-detail-dialog {
    width: 60% !important;
    max-width: 60% !important;
  }
  
  .course-detail-dialog .el-dialog {
    width: 60% !important;
    max-width: 60% !important;
  }
  
  .course-detail-dialog .el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
  }
  
  .course-detail-content {
    overflow: visible;
  }
  
  .course-detail-content table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .course-detail-content table th,
  .course-detail-content table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .course-detail-content table thead tr {
    background-color: #f5f7fa;
  }
  
  /* 自定义下拉框样式 */
  .select-container {
    width: 100%;
    max-width: 200px;
  }
  
  .custom-select {
    width: 100%;
  }
  
  .custom-select .el-input__inner {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    height: 32px;
    line-height: 32px;
  }
  
  .custom-select .el-input__inner:focus {
    border-color: #409eff;
  }
  
  .custom-select .el-input__suffix {
    right: 5px;
  }
</style>
